"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.refreshLogin = void 0;
const complex_data_1 = require("complex-data");
const complex_plugin_1 = require("complex-plugin");
const complex_utils_1 = require("complex-utils");
const complex_require_1 = require("complex-require");
const index_1 = require("../config/url/index");
const api_1 = __importDefault(require("@/api"));
const user_1 = require("@/data/user");
const currentDefaultUrl = (0, index_1.getCurrentUrl)('gateway');
class RefreshLogin extends complex_data_1.DefaultData {
    constructor(initOption) {
        super(initOption);
        this.status = false;
        this.data = {
            refreshToken: ''
        };
    }
    setRefreshToken(refreshToken) {
        this.data.refreshToken = refreshToken;
        (0, complex_utils_1.setLocalData)('refreshToken', this.data.refreshToken);
    }
    showFail() {
        if (!this.status) {
            this.status = true;
            const content = 'Token失效，请重新登录！';
            complex_plugin_1.notice.alert(content, 'TOKEN错误', () => {
                window.location.reload();
            });
            // setTimeout(() => {
            //   window.location.reload()
            // }, 5000)
        }
    }
    trigger() {
        return new Promise((resolve, reject) => {
            if (this.data.refreshToken) {
                if (!this.promise) {
                    this.promise = api_1.default.refreshToken.require({
                        secret: this.data.refreshToken
                    });
                }
                this.promise.then(res => {
                    this.$triggerLife('refreshToken', res.data.data);
                    resolve(res);
                }).catch(err => {
                    this.$triggerLife('logout');
                    this.setRefreshToken('');
                    this.showFail();
                    reject(err);
                });
            }
            else {
                this.$triggerLife('logout');
                this.setRefreshToken('');
                reject();
            }
        });
    }
}
exports.refreshLogin = new RefreshLogin({
    name: 'refreshLogin',
    prop: 'refreshLogin'
});
const requireData = new complex_require_1.Require({
    baseUrl: currentDefaultUrl,
    option: {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8'
        },
        validateStatus() {
            return true;
        }
    },
    rule: [
        {
            name: '五征网关',
            prop: 'default',
            token: {
                data: {
                    sign: {
                        require: true,
                        location: 'params',
                        data: 'sign'
                    },
                    timestamp: {
                        require: true,
                        location: 'params',
                        getData: function () {
                            return Date.now();
                        }
                    },
                    Authorization: {
                        require: true,
                        location: 'header'
                    },
                    'A-Sign': {
                        require: true,
                        location: 'header',
                        getData: function () {
                            return (0, user_1.encryptByAES)(Date.now().toString());
                        }
                    },
                    'X-Cs-User-Id': {
                        require: true,
                        location: 'header'
                    },
                    'X-Cs-Flow-User-Id': {
                        require: true,
                        location: 'header'
                    },
                    'X-Token-Issuer': {
                        require: true,
                        location: 'header',
                        data: 'ufo-cs'
                    },
                    'X-Request-Id': {
                        require: true,
                        location: 'header',
                        getData: function () {
                            return Date.now();
                        }
                    }
                }
            },
            checkUrl(url) {
                if (url.indexOf(currentDefaultUrl) > -1) {
                    return true;
                }
                else {
                    return false;
                }
            },
            format(response) {
                const res = {
                    status: 'fail'
                };
                if (response.data) {
                    res.data = response.data;
                    if (response.data.result === 'SUCCEED') {
                        res.status = 'success';
                        res.msg = response.data.errorMessage;
                    }
                    else if (response.data.errorCode === '000031' || response.data.errorCode === '000032') {
                        res.status = 'login';
                        res.code = response.data.errorCode;
                        res.msg = response.data.errorMessage;
                    }
                    else if (response.data.errorCode === 'N1000' || response.data.errorCode === 'N1009') {
                        res.status = 'login';
                        res.code = response.data.errorCode;
                        res.msg = response.data.errorMessage;
                    }
                    else {
                        res.code = response.data.errorCode;
                        res.msg = response.data.errorMessage || '接口请求返回失败且无错误信息！';
                    }
                }
                return res;
            },
            refreshToken() {
                return exports.refreshLogin.trigger();
            },
            refreshLogin() {
                return exports.refreshLogin.trigger();
            },
        }
    ]
});
const defaultRule = requireData.getRule('default');
(0, complex_utils_1.onEnvChange)({
    data: function () {
        const currentDefaultUrl = (0, index_1.getCurrentUrl)('gateway');
        requireData.changeBaseUrl(currentDefaultUrl);
        defaultRule.checkUrl = function (url) {
            if (url.indexOf(currentDefaultUrl) > -1) {
                return true;
            }
            else {
                return false;
            }
        };
    }
});
exports.default = requireData;
